import { render, staticRenderFns } from "./SupportBlock.vue?vue&type=template&id=2383a4e2&"
import script from "./SupportBlock.vue?vue&type=script&lang=js&"
export * from "./SupportBlock.vue?vue&type=script&lang=js&"
import style0 from "./SupportBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports